import React, { Component } from 'react';
import '../../css/components/CommonComponents/ShareMapPopup.css';
import {TallModalPopup} from "common-components";
import {commitMutation, graphql} from "react-relay";
import environment from "../../RelayEnvironment";
import SaveMapPopup from "../SaveMapPopup/SaveMapPopup";
import { apiBaseUrl } from "../../utility/utilities";
import $ from 'jquery';
import {ButtonComponent} from "common-components";

class ShareMapPopUp extends Component {

    constructor(props) {
        super(props);
        this.state = {
            isCopiedLink: false,
            copyLinkText: '',
            embedCode: '',
            isCopiedEmbedCode: false
        }
    }

    goBack = () => {
        if (this.props.history && this.props.history.location &&  this.props.history.location.hash){
            this.props.history.goBack()
        } else {
            this.props.closePopUp();
        }
    };

    
    handleCreateCopyLink = () => {
        const mutation = graphql`
            mutation ShareMapPopupCopyLinkMutation($input: CreateMapShareLinkInput!) {
            createMapShareLink(input: $input) {
                mapCardNode {
                    id
                }
            }
        }`;
        const centerAndzoom = this.props.getMapCenterAndZoom();

        const variables = {
            "input": {
                "savedAreaId": this.props.savedAreaIdSelected,
                "indicators": this.props.indicatorsObjectArray,
                "zoom": centerAndzoom.zoom,
                "center": {
                    "lng": centerAndzoom.centerLonLat[0],
                    "lat": centerAndzoom.centerLonLat[1]
                }
            }
        };
        //console.log("input values for save map",JSON.stringify(variables))

        commitMutation(
            environment,
            {
                mutation,
                variables,
                onCompleted: (response, errors) => {
                    if(response && response.createMapShareLink && response.createMapShareLink.mapCardNode) {
                        const copyLink = apiBaseUrl + "map/?id=" + response.createMapShareLink.mapCardNode.id;
                        this.setState({copyLink});
                    }
                },
                onError: (err) => {
                    console.error(err);
                    alert('Error saving map for link');
                    this.setState({copyLink: "Error saving map for link"});
                },
            },
        );
    };

    handleDownloadDataImage = () => {
        this.handleDownloadData()
        this.props.onExportMap()
    };

    handleDownloadData = () => {
        // define data to download and request CSV file
        // first check if we have indicators selected and are not already downloading
        if(this.state.downloadingInProgress===true) {
            return;
        }
        const {savedAreaIdSelected, filterByArea, indicatorIdArray} = this.props;
        if(indicatorIdArray == null || indicatorIdArray.length == 0) {
            this.props.onDownloadData(true);
            return;
        }

        this.setState({downloadingInProgress:true});
        // upload selected indicators and geography via mutation, use return value to download csv
        const mutation = graphql`
            mutation ShareMapPopupDownloadMapDataMutation($input: CreateDataSetDownloadInput!) {
                createDataSetDownload(input: $input) {
                    dataSetDownloadNode {
                      id
                    }
                }
            }    
            `;

        var geographicProfiles = [];
        if(filterByArea === true && savedAreaIdSelected != null && savedAreaIdSelected !== "") {
            var geographicFilters = [{"savedAreaId": savedAreaIdSelected}];
            geographicProfiles.push({"geographicFilters": geographicFilters});
        }
        const variables = {
            "input": {
                "indicators": this.props.indicatorIdArray,
                "geographicProfiles": geographicProfiles
            }
        };

        // get data with basic error handling and responsive progress dialogue
        commitMutation(
            environment,
            {
                mutation,
                variables,
                onCompleted: (response, errors) => {
                    this.setState({downloadingInProgress:false});
                    // download the file at download ID
                    window.location.assign(`${apiBaseUrl}bsdata/downloaddataset/${response.createDataSetDownload.dataSetDownloadNode.id}`);
                    console.log(`Download URL: ${apiBaseUrl}bsdata/downloaddataset/${response.createDataSetDownload.dataSetDownloadNode.id}`);
                    this.props.onDownloadData();
                },
                onError: (err) => {
                    console.error(err);
                    alert('Error downloading csv data');
                    this.setState({downloadingInProgress:false});
                    this.props.onDownloadData();
                },
            },
        );

    };

    handleCreateEmbedCode = () => {
        this.setState({embedCode: "Loading...", isCopiedEmbedCode: false});
        const mutation = graphql`
            mutation ShareMapPopupEmbedCodeMutation($input: CreateMapShareLinkInput!) {
            createMapShareLink(input: $input) {
                mapCardNode {
                    id
                }
            }
        }`;
        const centerAndzoom = this.props.getMapCenterAndZoom();
        const variables = {
            "input": {
                "savedAreaId": this.props.savedAreaIdSelected,
                "indicators": this.props.indicatorsObjectArray,
                "zoom": centerAndzoom.zoom,
                "center": {
                    "lng": centerAndzoom.centerLonLat[0],
                    "lat": centerAndzoom.centerLonLat[1]
                }
            }
        };
        //console.log("input values for save map",JSON.stringify(variables))

        commitMutation(
            environment,
            {
                mutation,
                variables,
                onCompleted: (response, errors) => {
                    if(response && response.createMapShareLink && response.createMapShareLink.mapCardNode) {
                        const link = apiBaseUrl + "map/embed/?id=" + response.createMapShareLink.mapCardNode.id;
                        const embedCode = `<iframe src="${link}" style="width: 100%; height: 95%"></iframe>`;
                        this.setState({embedCode});
                    }
                },
                onError: (err) => {
                    console.error(err);
                    alert('Error saving map for embed');
                    this.setState({embedCode: "Error saving map for embed"});
                },
            },
        );
        return true;
    };

    handleCopyEmbedCode = () => {
        window.document.getElementById("EmbedCode").select();
        document.execCommand('copy');
        //navigator.clipboard.writeText(this.state.embedCode)
        this.setState({isCopiedEmbedCode: true});
    };

    handleCopyLink = () => {
        window.document.getElementById("CopyLink").select();
        document.execCommand('copy');
        //navigator.clipboard.writeText(this.state.embedCode)
        this.setState({isCopiedLink: true});
    };

    render() {
        const { isCopiedLink, isCopiedEmbedCode, embedCode} = this.state;
        const {history: {location}, closePopUp, onExportMap } = this.props;
        return (
            <TallModalPopup closePopUp={closePopUp} goBack={this.goBack}>
                <div className={"row mx-0 " + (!location.hash ? "showMenu h-100" : "hideMenu")}>
                    <div className={"col-12 left-nav "  + (!location.hash ? " h-100" : "")}>
                        <div className="title mt-4">
                            <h3 className="font-20 pb-4">Share</h3>
                        </div>
                        <div className="bsui-leftnavmenu-open">
                            <ul>
                                <li className={"left-menu current-list"}>
                                    <a
                                        href="#copylink"
                                        onClick={this.handleCreateCopyLink}
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-darkLink"}/>
                                        Copy &amp; Share Link
                                        <span className="icon-right-arrow right-icon"/>
                                    </a>
                                </li>
                                <li className={"left-menu current-list"}>
                                    <a
                                        href="#save"
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-save"}/>
                                        Save
                                        <span className="icon-right-arrow right-icon"/>
                                    </a>
                                </li>
                                <li className={"left-menu current-list"}>
                                    <a
                                        href="#download"
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-download"}/>
                                        Download
                                        <span className="icon-right-arrow right-icon"/>
                                    </a>
                                </li>
                                <li className={"left-menu current-list"}>
                                    <a
                                        href="#embed"
                                        onClick={this.handleCreateEmbedCode}
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-embed"}/>
                                        Embed
                                        <span className="icon-right-arrow right-icon"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <SaveMapPopup {...this.props}
                              getMapCenterAndZoom={this.props.getMapCenterAndZoom}
                              getMapPngUrl={this.props.getMapPngUrl}
                              indicatorsObjectArray={this.props.indicatorsObjectArray}
                              handleCloseMapPopup={this.handleCloseMapPopup}
                              savedAreaId={this.props.savedAreaId}
                              centerAndzoom={this.props.centerAndzoom}/>

                <div className={"row mx-0 " + (location.hash === "#copylink" ? "showMenu h-100" : "hideSave")}>
                    <div className={"col-12 left-nav "  + (location.hash === "#copylink" ? " h-100" : "")}>
                        <div className="title mt-4">
                            <h3 className="font-20 pb-4">Copy Link</h3>
                            <div className="edit-card-right-menu">
                                <ButtonComponent
                                    buttonType="subtle"
                                    buttonState={isCopiedLink ? "saved" : ""}
                                    buttonTitle={isCopiedLink ? 'Copied' : 'COPY'}
                                    onClick={() => !isCopiedLink ? this.handleCopyLink() : null} />
                            </div>
                        </div>
                        <div className="bsui-leftnavmenu-open">
                            <ul>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                    <span className="left-menu-title">Share this read-only link</span>
                                </li>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                            <textarea
                                                id="CopyLink"
                                                ref={me => this.copyLinkText = me}
                                                readOnly={true} value={this.state.copyLink}/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className={"row mx-0 " + (location.hash === "#embed" ? "showMenu h-100" : "hideSave")}>
                    <div className={"col-12 left-nav "  + (location.hash === "#embed" ? " h-100" : "")}>
                        <div className="title mt-4">
                            <h3 className="font-20 pb-4">Embed</h3>
                            <div className="edit-card-right-menu">
                                <ButtonComponent
                                    buttonType="subtle"
                                    buttonState={isCopiedEmbedCode ? "saved" : ""}
                                    buttonTitle={isCopiedEmbedCode ? 'Copied' : 'COPY'}
                                    onClick={() => !isCopiedEmbedCode ? this.handleCopyEmbedCode() : null} />
                            </div>
                        </div>
                        <div className="bsui-leftnavmenu-open">
                            <ul>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                    <span className="left-menu-title">Copy and paste into your website</span>
                                </li>
                                <li className="left-menu-header pb-4 pt-0 pl-0">
                                            <textarea
                                                id="EmbedCode"
                                                ref={me => this.embedCodeText = me}
                                                readOnly={true} value={embedCode}/>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className={"row mx-0 " + (location.hash === "#download" ? "showMenu h-100" : "hideSave")}>
                    <div className={"col-12 left-nav "  + (location.hash === "#download" ? " h-100" : "")}>
                        <div className="title mt-4">
                            <h3 className="font-20 pb-4">Download</h3>
                        </div>
                        <div className="bsui-leftnavmenu-open">
                            <ul>
                                <li className={"left-menu current-list"}>
                                    <a
                                        onClick={this.handleDownloadData}
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-data"}/>
                                        Data
                                        <span className="icon-right-download right-icon"/>
                                    </a>
                                </li>
                                <li className={"left-menu current-list"}>
                                    <a
                                        onClick={onExportMap}
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-image"}/>
                                        Image
                                        <span className="icon-right-download right-icon"/>
                                    </a>
                                </li>
                                <li className={"left-menu current-list"}>
                                    <a
                                        onClick={this.handleDownloadDataImage}
                                        tabIndex={0}>
                                        <span className={"left-nav-icon left-icon-gift"}/>
                                        Data & Image
                                        <span className="icon-right-download right-icon"/>
                                    </a>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>

            </TallModalPopup>
        )
    }
}

export default ShareMapPopUp




// WEBPACK FOOTER //
// ./src/components/CommonComponents/ShareMapPopup.js